import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../core/services/data.service';
import { NotificationService } from '../../core/services/notification.service';
import {ActivityStatus} from "../models/activity-status/activity-status";

@Injectable()
export class ActivityStatusesService extends DataService<ActivityStatus, ActivityStatus> {

	constructor(
		http: HttpClient,
		notificationService: NotificationService) {
		super(http, notificationService);

		this.controllerName = 'activity-statuses';
	}
}
